<i18n>
{
	"en": {
		"PleaseInputToSearch": "Please input to search"
	},
	"vi": {
		"PleaseInputToSearch": "Gõ tên quyền để tìm kiếm hoặc tạo mới."
	}
}
</i18n>

<template>
	<div>
		<!-- Block tag employee, departement, title -->
		<div class="container-watcher--block-item">
			<h6 v-if="title" class="mb-2 custom-component--title">{{ title }}<span class="text-danger" v-if="isRequired">&nbsp;*</span>:</h6>
			<v-select
				taggable
				:ref="ref"
				label="name"
				v-bind="$attrs"
				v-on="$listeners"
				:filterable="false"
				:options="roles"
				:placeholder="placeholder"
				class="bg-white"
				:closeOnSelect="true"
				:getOptionKey="option => ref + option.id"
				@option:created="handleCreateNewRole"
				:create-option="newOptionText => handleAddingNewOption(newOptionText, roles)"
			>
				<template #option="{ name }">
					<div>
						{{ name }}
					</div>
				</template>
				<template #selected-option="{ name}">
					<p>{{ name }}</p>
				</template>
				<template #no-options>
					{{ noOptionsTitle ? noOptionsTitle : $t("PleaseInputToSearch") }}
				</template>
			</v-select>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";

import * as _ from "lodash";

export default {
	inheritAttrs: false,
	name: "CbsEmployeeRoles",
	props: {
		title: {
			type: String
		},
		placeholder: {
			type: String
		},

		noOptionsTitle: {
			type: String
		},
		isRequired: {
			type: Boolean
		},
		modelId: Number,
		modelType: String
	},
	components: {
		"v-select": vSelect
	},
	computed: {
		roles() {
			return this.$store.state.rolesManagement.roles;
		}
	},

	data() {
		return {
			ref: _.uniqueId("employeeRoles_")
		};
	},
	methods: {
		handleAddingNewOption(newOptionText, listOptions) {
			const existedOption = listOptions.find(option => option.name === newOptionText);
			if (!existedOption) {
				return { name: newOptionText };
			}
			return existedOption;
		},
		async handleCreateNewRole(newOption) {
			const refLoading = this.$refs && this.$refs[this.ref] && this.$refs[this.ref].toggleLoading;
			try {
				try {
					if (refLoading) {
						refLoading(true);
					}
					const permissions = this.mapRolePermissionBooleanToString();
					await this.$store.dispatch("rolesManagement/addRole", { name: newOption.name, permissions: permissions, description: "" });
				} catch (error) {
					console.error("handleCreateNewRole: ", error);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				if (refLoading) {
					refLoading(false);
				}
			}
		},
		mapRolePermissionBooleanToString() {
			let _rolePermissions = {};
			this.$store.state.rolesManagement.moduleRoles.map(moduleRole => {
				moduleRole.permissions.map(item => {
					_rolePermissions[item.permission] = this.$constant.ROLES_VALUE.FALSE;
				});
			});
			return JSON.stringify(_rolePermissions);
		}
	}
};
</script>
<style lang="scss">
.container-watcher--block-item {
	.vs__selected {
		.inline-block {
			line-height: 100%;
		}
		.nucleo {
			color: var(--color-white);
		}
	}
}
</style>
